import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/question.svg';
const Question = () => React.createElement(IconSvg, null);
export default Question;
